// src/onboarding/aha/ProbeScoreLesson.jsx
import React, { useEffect, useState } from "react";
import { motion, useMotionValue, animate } from "framer-motion";
import ConfettiBurst from "./ConfettiBurst";
import ScoreBar from "./ScoreBar";

export default function ProbeScoreLesson({
  previousScore,
  newScore,
  onContinue,
}) {
  // Raw motion value for animation
  const score = useMotionValue(previousScore);

  // This local state will track the current number to display
  const [displayScore, setDisplayScore] = useState(previousScore);

  useEffect(() => {
    // Animate raw score value
    const controls = animate(score, newScore, {
      duration: 1.2,
      ease: "easeOut",
      onUpdate: (latest) => {
        setDisplayScore(Math.round(latest));
      },
    });

    return () => controls.stop();
  }, [newScore]);

  return (
    <div style={S.wrap}>
      <ConfettiBurst />

      <motion.div style={S.scoreText}>
        {displayScore}%
      </motion.div>

      <ScoreBar value={newScore} />

      <p color={S.subtitle}>
        Nice! You're getting closer to reading charts like a pro.
      </p>

      {/* <button style={S.btn} onClick={onContinue}>Continue</button> */}
    </div>
  );
}

const S = {
  wrap: { textAlign: "center", marginTop: 30 },
  scoreText: { fontSize: 64, fontWeight: 800, color: "#FF7C24" },
  subtitle: { opacity: 0.8, marginTop: 14, fontSize: 16 },
  btn: {
    marginTop: 32,
    padding: "14px 26px",
    background: "#FF7C24",
    borderRadius: 16,
    fontWeight: 800,
    color: "#232830",
  },
};